module.exports = __webpack_public_path__ + "static/media/tether.4eff2a3e.svg";